import { AbilityBuilder } from '@casl/ability';
import EventBus from '@/events/event.bus';

let ability = AbilityBuilder.define((can) => {});

EventBus.$on('update-permissions', (permissions) => {
  let rules = [];
  permissions.forEach((permission) => {
    let arr = permission.split('.');
    let rule = {
      subject: arr[0],
      actions: arr[1],
    };
    rules.push(rule);
  });

  ability.update(rules);
});

export default ability;
